exports.f = Object.getOwnPropertySymbols;



//////////////////
// WEBPACK FOOTER
// /Users/zhaolinxu/GitHub/IdleAnt/~/core-js/modules/_object-gops.js
// module id = ../../../../core-js/modules/_object-gops.js
// module chunks = 0